module.exports = __webpack_public_path__ + "static/media/lALPAuoR5ZXpjaDNBcbNBgw_1548_1478.ffec4c58.png";